import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { PlanMetricRows } from "../pinned-row-constants";
import classNames from "classnames";
import { getTotalTypesLabel } from "helpers/metrics/legacy-metrics";

export const PlanMetricLabelColumn: React.FunctionComponent<any> = ({ planRowType, totalType, style }) => {
    let planValue = "";
    if (planRowType === PlanMetricRows.Diff) {
        planValue = formatMessage("Diff");
    } else if (planRowType === PlanMetricRows.Plan) {
        planValue = formatMessage("Plan");
    } else if (planRowType === PlanMetricRows.Total) {
        planValue = formatMessage("Total");
    }

    const totalValue = getTotalTypesLabel(totalType);

    return (
        <div style={style} className="planHeader">
            {planRowType === PlanMetricRows.Plan && (
                <div className={classNames("planTitle", "planType")}>{totalValue}</div>
            )}
            <div className={classNames("planTitle", `${planRowType}MetricType`)}>
                <span>{planValue}</span>
            </div>
        </div>
    );
};
